// TabContent1.js
import React, { useState } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import Subheading from '../../../../theme/text/Subheading';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import NumberInput from '../../../../theme/inputs/NumberInput';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../../../../theme';
import * as yup from "yup";
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import { yupRequired } from '../../../../../utils/validation';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';

// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import ShTimePicker from '../../../../theme/ShTimePicker';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    
    const data = {...props.data};
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    
    const handleChange = (key, val) => {
        if (val.isValid()) {
            props.handleDataUpdate({ [key]: dayjs(val).format("HH:mm") });
        }
    };

        return (
            <>
            <Box 
                sx={{
                    background: colors["blue"][100],
                    color: colors["blue"][400],
                    padding:2,
                    width:1,
                    marginBottom: 2
                }}
            >
                <Typography fontWeight={"bold"} fontSize={"17"}>
                    {t("mp_add_shipper_pickuptimes_title")}
                </Typography>
                <Box sx={{paddingTop:0.5, maxWidth: 500}}>
                    <Typography fontSize={"14"}>
                    {t("mp_add_shipper_pickuptimes_text")}
                    </Typography>
                </Box>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box 
                sx={{
                    width:1,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >

                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("mon_fri")}</Text>&nbsp;
                </Box>
                
                {/* <Box    
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                > */}
                    
                    {/* <TimePicker */}
                    {/* <TimePicker 
                        btnSize={"24"} 
                        showTimeSelect 
                        showTimeSelectOnly
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        format="HH:mm"
                        value={data.mon_fri}
                    onChange={(e) => handleChange('mon_fri', e)}/> */}
                    
                    <ShTimePicker
                        noUseEffect
                        value={dayjs(data.mon_fri, "HH:mm")}
                        onChange={(e) => {
                            handleChange('mon_fri', e)
                        }}
                    />
                
                {/* </Box> */}
                </Box>
                <Box 
                    sx={{
                        width:1,
                        paddingTop: 2,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text>{t("saturday")}</Text>&nbsp;
                    </Box>
                    

                    <ShTimePicker
                        noUseEffect
                        value={dayjs(data.saturday, "HH:mm")}
                        onChange={(e) => {
                            handleChange('saturday', e)
                        }}
                    />
                </Box>
                <Box 
                    sx={{
                        width:1,
                        paddingTop: 2,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text>{t("sunday")}</Text>&nbsp;
                    </Box>
                    

                    <ShTimePicker
                        noUseEffect
                        value={dayjs(data.sunday, "HH:mm")}
                        onChange={(e) => {
                            handleChange('sunday', e)
                        }}
                    />
                </Box>
            </LocalizationProvider>
            </>
        );
    };

const ShipperPickupTimes = (props) => {
    const { t } = useTranslation();
    const schema = yup.object({

    });
    const { maxSteps } = useSelector((state) => state.progressiontabs);

    return (
        <ProgressionTab 
            tabId="tabPickupTimes" 
            subtitle={t("pickuptimes")} 
            step={5}
            nextTab={maxSteps === 6 ? "tabAuthorisation" : null}
            maxSteps={maxSteps}
            schema={schema}
        >
            <Content />
        </ProgressionTab>
    )
}

export default ShipperPickupTimes;

